import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import style from "../../components/replica/replica.module.scss";
import rep1 from "../../../assets/images/rep1.jpg";
import rep2 from "../../../assets/images/rep2.jpg";
import rep3 from "../../../assets/images/rep3.jpg";
import rep4 from "../../../assets/images/rep4.jpg";
import rep5 from "../../../assets/images/rep5.jpg";
import { withTranslation } from "react-i18next";
import { withRouter } from "react-router";
import {
  Header,
  Banner,
  Plans,
  About,
  Contact,
  Mainguy,
  Footer,
  Scrollbutton,
} from "../../components/replica";
import { useParams } from "react-router-dom";
import ReplicaSiteService from "../../../service/replica/replica";
import AppInfoservice from "../../../service/common/Appinfo";
import { red } from "@mui/material/colors";

function Home() {
  const { user_name, admin, genderhere } = useParams();
  // const params = useParams();

  const service = new ReplicaSiteService();
  const app = new AppInfoservice();

  const [state, setState] = useState({
    header_data: [],
    policy_data: [],
    banner_data: [],
    loding: true,
    logo: "",
  });

  const [gen, setGen] = useState({
    gender: genderhere,
  });

  const [newThings, setNewThings] = useState({
    bgimage: "",
    extralink1: {
      image: "",
      link: "",
    },
    extralink2: {
      image: "",
      link: "",
    },
    store: {
      image: "",
      link: "",
    },
    presentation: "",
    videoPresentation: "",
    signup: "",
  });

  useEffect(() => {
    service.getHeader(user_name, admin).then((res) => {
      if (res.status) {
        setState((prevState) => ({
          ...prevState,
          header_data: res.data,
          loding: false,
        }));
      } else {
        alert("Invalid Url");
      }
      app.Appinfo().then((res) => {
        if (res.status) {
          setState((prevState) => ({
            ...prevState,
            logo: res.data.company_info.login_logo,
          }));
        }
      });
    });

    service.getGenderBasedData(JSON.stringify(gen)).then((res) => {
      if (res.status) {
        setNewThings((prev) => ({
          ...prev,
          bgimage: res.data.backgroundimage,
          extralink1: {
            image: res.data.extralink1.image,
            link: res.data.extralink1.link,
          },
          extralink2: {
            image: res.data.extralink2.image,
            link: res.data.extralink2.link,
          },
          store: {
            image: res.data.store.image,
            link: res.data.store.link,
          },
          presentation: res.data.presentation,
          videoPresentation: res.data.videoPresentation,
          signup: res.data.signup,
        }));
      }
    });

    getBanner();
    getPolicy();
    //   } else {
    //     alert("Invalid Admin user name");
    //   }
    // });
  }, []);

  const storeappend = newThings.store.link + `&sp_name='${user_name}'`;
  const extralink1append =
    newThings.extralink1.link + `&sp_name='${user_name}'`;
  const extralink2append =
    newThings.extralink2.link + `&sp_name='${user_name}'`;

  const getBanner = () => {
    service.getBanner(user_name).then((res) => {
      if (res.status) {
        setState((prevState) => ({
          ...prevState,
          banner_data: res.data,
        }));
      } else {
        alert("Invalid Url");
      }
    });
  };
  const getPolicy = () => {
    service.getPolicy(user_name).then((res) => {
      if (res.status) {
        setState((prevState) => ({
          ...prevState,
          policy_data: res.data,
        }));
      } else {
      }
    });
  };

  return (
    // <div className="h-100" style={{backgroundImage: `url(http://demo8.infinitemlmdemo.com/rodnelio/uploads/images/banners/default_banner.jpg)`,backgroundRepeat:'no-repeat',backgroundSize:'cover'}}>
    // <div className="h-100" style={{ backgroundImage: `url(http://demo8.infinitemlmdemo.com/rodnelio/uploads/images/banners/default_banner.jpg)`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
    // <div className="h-100" style={{ backgroundImage: `url(${newThings.bgimage})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
    <div className={`h-100 ${style.lgbackground}`}>
      {!state.loding && (
        <>
          {/* {state.header_data && (
            <Header
              data={state.header_data}
              user_name={user_name}
              logo={state.logo}
              showmenu={true}
            />
          )} */}

          {/* {state.banner_data && state.policy_data && (
            <Banner data={state} header_data={state.header_data} />
          )} */}

          <div className="row">
            {/* <div className={`col-sm-12 pt-4 fixed-top one ${style.whitebg}`}  style={{ "textAlign": "center","zIndex" : "1000" }}>
              <h2 style={{ "fontWeight": "bolder", "color": "#480dff" }}>EARN UNLIMITED DOLLARS DAILY !!!</h2>
              <h4 style={{ "fontWeight": "200", "color": "black" }}>WELCOME TO</h4>
              <h3 style={{ "fontWeight": "200", "color": "#1fd4e2" }}>My Diamond Extreme Webpage !!!</h3>
              <p style={{ "fontWeight": "bold", "background": "white", "color": "black" }} className={style.pclass}>I'm here to assist you to start this amazing oppurtunity.</p>
            </div> */}

            <div
              className={`col-sm-4 col-12 pt-5 fixed-top ${style.mbunsettop} one`}
              style={{ zIndex: "10" }}
            >
              {state.policy_data && (
                <Mainguy data={state} header_data={state.header_data} />
              )}
            </div>

            {/* <div className="col-sm-8 col-12 pt-5 offset-sm-4 three" style={{ "marginTop": "10%", "overflowY": "scroll", "height": "500px" }}> */}
            <div
              className={`col-sm-8 col-12 pt-5 offset-sm-4 three ${style.heightmaindiv} ${style.brthe}`}
              style={{ marginTop: "10%", overflowY: "scroll", height: "500px" }}
            >
              <div className="row">
                <div
                  className="col-sm-6 pt-5 pb-5"
                  style={{ textAlign: "center" }}
                >
                  <a href={storeappend}>
                    {" "}
                    <img
                      style={{
                        border: "5px solid white",
                        height: "200px",
                        width: "300px",
                      }}
                      src={newThings.store.image}
                      alt="NOthing here"
                    />{" "}
                  </a>
                  {/* <p style={{"color" : "white", "fontWeight" : "bold"}}>My ecommerce store</p> */}
                </div>
                <div
                  className="col-sm-6 pt-5 pb-5"
                  style={{ textAlign: "center" }}
                >
                  <a href={extralink1append}>
                    {" "}
                    <img
                      style={{
                        border: "5px solid white",
                        height: "200px",
                        width: "300px",
                      }}
                      src={newThings.extralink1.image}
                      alt="NOthing here"
                    />{" "}
                  </a>
                  {/* <p style={{"color" : "white", "fontWeight" : "bold"}}>Extra link</p> */}
                </div>
                <div
                  className="col-sm-6 pt-5 pb-5"
                  style={{ textAlign: "center" }}
                >
                  <a href={extralink2append}>
                    {" "}
                    <img
                      style={{
                        border: "5px solid white",
                        height: "200px",
                        width: "300px",
                      }}
                      src={newThings.extralink2.image}
                      alt="NOthing here"
                    />{" "}
                  </a>
                  {/* <p style={{"color" : "white", "fontWeight" : "bold"}}>Extra link</p> */}
                </div>

                <div
                  className="col-sm-6 pt-5 pb-5"
                  style={{ textAlign: "center" }}
                >
                  <a href="https://youtu.be/CPLFzNepms0">
                    <img
                      style={{
                        border: "5px solid white",
                        height: "200px",
                        width: "300px",
                      }}
                      src={newThings.videoPresentation}
                      alt="NOthing here"
                    />
                  </a>
                  {/* <p style={{"color" : "white", "fontWeight" : "bold"}}>English Business presentation</p> */}
                </div>

                <div
                  className="col-sm-6 pt-5 pb-5"
                  style={{ textAlign: "center" }}
                >
                  <a href="https://youtu.be/82YVVhO2aHw">
                    <img
                      style={{
                        border: "5px solid white",
                        height: "200px",
                        width: "300px",
                      }}
                      src={newThings.presentation}
                      alt="NOthing here"
                    />
                  </a>
                  {/* <p style={{"color" : "white", "fontWeight" : "bold"}}>TAGALOG Business Presentation</p> */}
                </div>

                <div
                  className="col-sm-6 pt-5 pb-5"
                  style={{ textAlign: "center" }}
                >
                  {state.header_data.regsitration_url == "" ? (
                    <img
                      style={{
                        border: "5px solid white",
                        height: "200px",
                        width: "300px",
                      }}
                      src={newThings.signup}
                      alt="NOthing here"
                    />
                  ) : (
                    <a href={state.header_data.regsitration_url}>
                      <img
                        style={{
                          border: "5px solid white",
                          height: "200px",
                          width: "300px",
                        }}
                        src={newThings.signup}
                        alt="NOthing here"
                      />
                    </a>
                  )}
                  {/* <p style={{"color" : "white", "fontWeight" : "bold"}}>Sign up now !</p> */}
                </div>
              </div>
            </div>
          </div>
          {/* {state.policy_data && <Plans data={state} />} */}
          {/* {state.policy_data && <About data={state} />} */}
          {/* {state.policy_data && <Contact data={state} user_name={user_name} />} */}
          {/* <Scrollbutton /> */}
          {/* {state.policy_data && <Footer data={state} user_name={user_name} />} */}
        </>
      )}
    </div>
  );
}

export default withTranslation()(withRouter(Home));
